<template>
  <div class="wrapper">
    <parallax class="page-header header-filter"></parallax>
    <div class="">
      <div class="section text-center t_step t_content">
        <md-card class="container">
          <div class="md-layout text-left">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-toolbar class="md-primary">
                <div class="md-toolbar-row">
                  <div class="md-toolbar-section-start">
                    <h3 class="md-title text-bold">ALL LINKS</h3>
                    <md-list>
                      <md-list-item href="manageMeetingRoom">
                        <p>Change Meeting Room</p>
                      </md-list-item>

                      <md-list-item href="manageGuestRoom">
                        <p>Change Guest Room</p>
                      </md-list-item>

                      <md-list-item href="meetingHistory">
                        <p>Meeting Reservation</p>
                      </md-list-item>

                      <md-list-item href="guestHistory">
                        <p>Guest Reservation</p>
                      </md-list-item>

                    </md-list>
                  </div>
                  <div class="md-toolbar-section-end">
                    <md-button
                      class="md-just-icon md-simple md-white md-toolbar-toggle"
                    >
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                    </md-button>

                    <div class="md-collapse"></div>
                  </div>
                </div>
              </md-toolbar>
            </div>
            <div class="md-layout-item md-size-100">
              <div class="title">
                <h3>Meeting Room Reservation History</h3>
              </div>
            </div>
            <div class="md-layout-item md-size-100">
              <vxe-table :data="sqlData" height="600" :edit-rules="validRules" border highlight-hover-row row-class-name="t_col" :loading="false" resizable :edit-config="{trigger: 'click', mode: 'cell'}" >
                <vxe-table-column title="Date" field="date"></vxe-table-column>
                <vxe-table-column title="Order NO" field="order_id"></vxe-table-column>
                <vxe-table-column title="Name" field="userName"></vxe-table-column>
                <vxe-table-column title="View More" type="expand" width="60">
                  <template v-slot:content="{ row }">
                    <ul>
                      <li>
                        <span>Invoice NO: </span>
                        <span>{{ row.invoiceId }}</span>
                      </li>
                      <li>
                        <span>Room: </span>
                        <span>{{ row.roomName }}</span>
                      </li>
                      <li>
                        <span>Check In: </span>
                        <span>{{ row.checkInDate }}</span>
                      </li>
                      <li>
                        <span>Period: </span>
                        <span>{{ getPeriod(row.period) }}</span>
                      </li>
                      <li>
                        <span>Set Up: </span>
                        <span>{{ row.setup }}</span>
                      </li>
                      <li>
                        <span>Long Table: </span>
                        <span>{{ row.longTable }}</span>
                      </li>
                      <li>
                        <span>Round Table: </span>
                        <span>{{ row.roundTable }}</span>
                      </li>
                      <li>
                        <span>Chairs: </span>
                        <span>{{ row.chairs }}</span>
                      </li>
                    </ul>
                    <p>Note: {{ row.note }}</p>
                  </template>
                </vxe-table-column>
                <vxe-table-column title="Invoice NO" field="invoiceId"></vxe-table-column>
                <vxe-table-column title="Room" field="roomName"></vxe-table-column>
                <vxe-table-column title="Check In" field="checkInDate"></vxe-table-column>
                <vxe-table-column title="Name" field="userName"></vxe-table-column>
                <vxe-table-column title="Email" field="email"></vxe-table-column>
                <vxe-table-column title="Phone" field="phone"></vxe-table-column>
                <vxe-table-column title="Meeting Type" field="meeType"></vxe-table-column>
                <vxe-table-column title="Room Price" field="paymentGross"></vxe-table-column>
                <vxe-table-column title="Tax" field="tax"></vxe-table-column>
                <vxe-table-column title="Total Payments" field="payments" show-overflow></vxe-table-column>
              </vxe-table>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<link rel="stylesheet" href="https://unpkg.com/vxe-table/lib/index.css"/>
<script src="https://unpkg.com/xe-utils"></script>
<script src="https://unpkg.com/vxe-table"></script>
<script>
  import axios from 'axios'
  export default {
    prop: {
    },
    data: () => {
      const roleValid = (rule, value, callback) => {
        if (!isNaN(value)) {
          value = parseInt(value).toFixed(2)
          callback()
        } else {
          callback(new Error('wrong'))
        }
      }
      return {
        sqlData: [],
        flag: false,
        content: '',
        validRules: {
          
        }
      }
    },
    directives: {
      numberOnly: {
        bind: function(el) {
          el.handler = function() {
            el.value = Number(el.value.replace(/\D+/, ''))
          }
          el.addEventListener('input', el.handler)
        },
        unbind: function(el) {
          el.removeEventListener('input', el.handler)
        }
      }
    },
    methods: {
      getPeriod (period) {
        if (period === '1') {
          period = 'Full Day'
        } else if (period === '2') {
          period = 'Morning 7am - 1pm'
        } else if (period === '3') {
          period = 'Evening 4pm -12am'
        }
        return period
      },
      toggleExpandChangeEvent ({ row, expanded }) {
        console.log('行展开事件' + expanded, 'sdfsdf' , row)
      },
      cookie: function () {
        let that = this
        if (this.$cookies.isKey("user_session")) {
          let data = JSON.stringify({"name": that.$cookies.get("user_session").name,"password":that.$cookies.get("user_session").password});
          // axios.post('/cgi-bin/php/confirmUser.php', data).then((res) => {
          axios.post('https://www.orangetreetx.com/cgi-bin/php/confirmUser.php', data).then((res) => {
            if(res.status === 200 && res.data.result != false) {
              // that.$cookies.set("user_session", res.data.result[0])
              // console.log(that.$cookies.get("user_session").name, that.$cookies.get("user_session").password)
              console.log('success')
            } else {
              this.$router.push({ path:'/login' })
            }
          }).catch((error) => {
            console.log(error)
          }).finally((res) => {

          })
        } else {
          this.$router.push({ path:'/login' })
        }
      },
      getData: function () {
        let that = this
        let data = JSON.stringify({"changeFlag": that.flag,"content":that.content});
        // axios.post('/cgi-bin/php/getMeetHistory.php', data).then((res) => {
        axios.post('https://www.orangetreetx.com/cgi-bin/php/getMeetHistory.php', data).then((res) => {
          // console.log(res.data)
          // if(res.status === 200 && res.data.result != false) {
          //   if(that.type == 1) {
          //     this.$router.push({ path:'/manageMeetingRoom' })
          //   } else if(that.type == 2) {
          //     this.$router.push({ path:'/manageGuestRoom' })
          //   }
          // } else {
          //   alert('Can not found username & password!')
          // }
          that.sqlData = res.data.result
        }).catch((error) => {
          console.log(error)
        }).finally((res) => {

        })
      },
      editActivedEvent ({ row, column }, event) {
        // console.log(`打开 ${column.title} 列编辑`)
      },
      editClosedEvent ({ row, column }, event) {
        this.flag = true
        // console.log(`关闭 ${column.title} 列编辑`)
      }
    },
    created() {
      
    },
    mounted() {
      this.cookie()
      this.getData()
      this.flag = false
      this.content = ''
    },
    destroyed() {
      this.$cookies.remove("user_session")
    },
  }
</script>

<style lang="scss" scoped>
  .page-header {
    height: auto;
  }
  .t_main {
    height: 100%;
    position: relative;
  }
  .md-ripple > span {
    left: auto;
    width: auto;
  }
  .t_content {
    padding-top: 0px;
    .container {
      margin-top: 0px;
      padding: 20px 20px 60px 20px;
    }
  }
  .t_step{
    padding: 100px 0px 10px;
    h2{
      padding-top:20px;
    }
  }
</style>
<style lang="scss">
  .vxe-table {
    color: #333!important;
    font-weight: bold;
  }
</style>